import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { assignDocusignEvent, DOCUSIGN_DOC_TYPES } from '../../services/workspaceService';
import { listClosings } from '../../services/closingService';

// Aviso de firma de DocuSign (webhook, public/api/docusign-webhook.php): el
// admin confirma a qué reclamo pertenece (si el correo del firmante coincide
// con varios) y qué documento se firmó (LOR, SPOL o uno de los Closings del
// reclamo). No lo marca como firmado: registra la firma y el PDF se sube con el
// botón de siempre (assignDocusignEvent en workspaceService.js).
const money = value => (typeof value === 'number' ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value) : '');
const claimLabel = c => [c.claimNumber && `#${c.claimNumber}`, c.clientName].filter(Boolean).join(' - ') || c.id;

export default function DocusignAssign({ item, es, busy, perform }) {
  const candidates = item.docusignCandidates || [];
  const [claimId, setClaimId] = useState(item.claimRecordId || '');
  const [target, setTarget] = useState('');
  const [closings, setClosings] = useState([]);

  useEffect(() => {
    setTarget('');
    setClosings([]);
    if (!claimId || item.assigned) return undefined;
    let active = true;
    listClosings(claimId).then(list => { if (active) setClosings(list); }).catch(() => { if (active) setClosings([]); });
    return () => { active = false; };
  }, [claimId, item.assigned]);

  if (item.assigned) {
    const claim = candidates.find(c => c.id === item.claimRecordId);
    return (
      <p className="team-docusign-done">
        <i className="fa-solid fa-circle-check" aria-hidden="true" />{' '}
        {es ? 'Registrado en el documento. Falta subir el PDF firmado desde el reclamo.' : 'Recorded on the document. The signed PDF still needs to be uploaded from the claim.'}
        {claim && ` (${claimLabel(claim)})`}
      </p>
    );
  }
  if (candidates.length === 0) {
    return <p className="team-docusign-note">{es ? 'Ningún reclamo tiene el correo del firmante. Registra la firma desde el reclamo.' : 'No claim has the signer email. Record the signature from the claim.'}</p>;
  }

  const openClosings = closings.filter(c => c.status !== 'signed');
  const confirm = () => perform(async () => {
    try {
      await assignDocusignEvent(item.id, claimId, target);
      toast.success(es ? 'Firma registrada. Sube el PDF firmado desde el reclamo.' : 'Signature recorded. Upload the signed PDF from the claim.');
    } catch (err) {
      if (err.message !== 'ALREADY_SIGNED') throw err;
      toast.error(es ? 'Ese documento ya está firmado y respaldado.' : 'That document is already signed and backed up.');
    }
  });

  return (
    <div className="team-docusign-assign">
      {candidates.length > 1 ? (
        <label>{es ? 'Reclamo' : 'Claim'}
          <select value={claimId} onChange={event => setClaimId(event.target.value)} disabled={busy}>
            <option value="">{es ? 'Elegir reclamo...' : 'Choose claim...'}</option>
            {candidates.map(c => <option key={c.id} value={c.id}>{claimLabel(c)}</option>)}
          </select>
        </label>
      ) : <span>{claimLabel(candidates[0])}</span>}
      <label>{es ? 'Documento' : 'Document'}
        <select value={target} onChange={event => setTarget(event.target.value)} disabled={busy || !claimId}>
          <option value="">{es ? 'Elegir documento...' : 'Choose document...'}</option>
          {DOCUSIGN_DOC_TYPES.map(type => <option key={type} value={type}>{type.toUpperCase()}</option>)}
          {openClosings.map(c => (
            <option key={c.id} value={`closing:${c.id}`}>
              {['Closing', c.paymentType, c.checkNumber && `${es ? 'cheque' : 'check'} ${c.checkNumber}`, money(c.netToClient)].filter(Boolean).join(' - ')}
            </option>
          ))}
        </select>
      </label>
      <button type="button" className="team-btn-primary" disabled={busy || !claimId || !target} onClick={confirm}>
        {es ? 'Registrar firma' : 'Record signature'}
      </button>
    </div>
  );
}
